<template>
  <section class="final-cta-section">
    <div class="container h-100 position-relative">
      
      <div class="row justify-content-center text-center pt-5 position-relative z-index-10">
        <div class="col-lg-8">
          <h2 class="text-white fw-bold mb-3" style="font-size: 1.8rem;">
            Vous avez choisi Nolido, et<br>
            <span class="position-relative d-inline-block">
              vous avez raison...
              <svg class="underline-svg" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12 C 50 6, 150 6, 195 10" stroke="#F5A847" stroke-width="2.5" stroke-linecap="round"/>
              </svg>
            </span>
          </h2>
          <button class="btn btn-download-cta rounded-pill mt-2">
            Télécharger maintenant
          </button>
        </div>
      </div>

      <!-- Absolute Positioned Images (Desktop) -->
      <div class="phone-wrapper d-none d-lg-block">
         <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="phone-app-img">
      </div>

      <div class="collage-wrapper d-none d-lg-block">
         <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="collage-img">
      </div>

      <!-- Stacked Layout for Mobile/Tablet -->
       <div class="row align-items-center mt-5 d-flex d-lg-none">
        <div class="col-12 text-center mb-4">
           <div class="collage-wrapper">
              <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="img-fluid collage-img">
           </div>
        </div>
        <div class="col-12 text-center p-0">
          <div class="phone-wrapper">
            <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="img-fluid phone-app-img">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CtaSection'
}
</script>

<style scoped>
/* Final CTA Section */
.final-cta-section {
  background-color: #2F2113;
  position: relative;
  overflow: hidden;
  height: 700px; /* Limit height */
  padding-top: 2rem;
  background-image: url('~@/assets/img/bande_gauche.png');
  background-position: left 50px;
  background-repeat: no-repeat;
  background-size: 350px auto;
}

.decoration-curve {
  top: 60px !important;
  left: 0 !important;
  opacity: 1;
  z-index: 1;
  width: 400px;
}

/* Increased underline size */
.underline-svg {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 250px; 
  height: auto;
}

.btn-download-cta {
  background-color: #eebb89;
  color: #2F2113;
  font-weight: 700;
  border: none;
  font-size: 0.95rem; /* Reduced font size */
  padding: 0.6rem 2rem; /* Reduced padding */
  box-shadow: 0 4px 0 #c29568;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  z-index: 10;
}

.btn-download-cta:hover {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #c29568;
}

/* Positioning phone absolute bottom-left */
.phone-wrapper {
  position: absolute;
  bottom: -40px; /* Cut off at bottom */
  left: 5%;
  z-index: 5;
  width: 280px; 
}

.phone-app-img {
  width: 100%;
  height: auto;
  transform: rotate(0deg); /* Ensure straight */
}

/* Positioning collage absolute bottom-right */
.collage-wrapper {
  position: absolute;
  bottom: 60px;
  right: 2%;
  z-index: 5;
  width: 360px;
}

.collage-img {
  width: 100%;
  height: auto;
  transform: rotate(3deg);
  border-radius: 12px;
  box-shadow: none;
}

@media (max-width: 991px) {
  .final-cta-section {
    height: auto;
    min-height: 500px;
    padding-bottom: 0;
    background-image: none; /* Hide background on mobile to prevent overlap */
    padding-top: 3rem;
  }
  
  .phone-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    margin-top: 2rem;
    margin-bottom: -10px; /* Flush to bottom */
    display: inline-block;
  }
  
  .collage-wrapper {
    position: relative;
    bottom: 0;
    right: 0;
    display: inline-block;
  }
  
  .collage-img {
    transform: rotate(0);
  }
}
</style>
